
import { Options, prop, Vue } from "vue-class-component";
import Checkbox from "primevue/checkbox";
import CustomDropdown from "@/app/ui/components/custom-dropdown/index.vue";

class Props {
  status = prop<string>({ default: "" });
  type = prop<string>({ default: "" });
  isCod = prop<string>({ default: "" });
  isMisbookingPotential = prop<string>({ default: "" });
}

@Options({
  emits: ["apply", "reset", "cancel"],
  components: {
    Checkbox,
    CustomDropdown
  }
})
export default class FilterPopoverDistrict extends Vue.with(Props) {
  isOpen = false;

  statusOptions = [
    { name: "Semua", value: "" },
    { name: "Active", value: "active" },
    { name: "Inactive", value: "inactive" }
  ];
  codOptions = [
    { name: "Semua", value: "" },
    { name: "Active", value: "yes" },
    { name: "Inactive", value: "no" }
  ];
  typeOptions = [
    { name: "Within City", value: "within-city" },
    { name: "Forward Area", value: "forward-area" },
    { name: "PT POS", value: "pt-pos" },
    { name: "PT POS Lanjutan", value: "pt-pos-lanjutan" }
  ];

  localStatus = { name: "Semua", value: "" };
  localType: string[] = [];
  localIsCod = { name: "Semua", value: "" };
  localMisbookingYes = false;
  localMisbookingNo = false;

  syncFromProps() {
    this.localStatus =
      this.statusOptions.find((option) => option.value === this.status) ||
      this.statusOptions[0];
    this.localType = this.type ? this.type.split(",").filter(Boolean) : [];
    this.localIsCod =
      this.codOptions.find((option) => option.value === this.isCod) ||
      this.codOptions[0];
    this.localMisbookingYes = this.isMisbookingPotential === "yes";
    this.localMisbookingNo = this.isMisbookingPotential === "no";
  }

  togglePopover() {
    if (this.isOpen) {
      this.closePopover();
    } else {
      this.syncFromProps();
      this.isOpen = true;
    }
  }

  closePopover(event?: MouseEvent) {
    if (event) {
      const path =
        typeof event.composedPath === "function"
          ? event.composedPath()
          : ((event as unknown) as { path?: EventTarget[] }).path;
      if (
        (path && this.$el && path.includes(this.$el)) ||
        (this.$el && event.target && this.$el.contains(event.target as Node))
      ) {
        return;
      }
    }
    this.isOpen = false;
  }

  onSelectStatus(option: { name: string; value: string }) {
    this.localStatus = option;
  }

  onSelectCod(item: { name: string; value: string }) {
    this.localIsCod = item;
  }

  onChangeMisbookingYes() {
    if (this.localMisbookingYes) {
      this.localMisbookingNo = false;
    }
  }

  onChangeMisbookingNo() {
    if (this.localMisbookingNo) {
      this.localMisbookingYes = false;
    }
  }

  get typeDisplayValue() {
    if (!this.localType.length) {
      return "";
    }
    const first = this.typeOptions.find(
      (option) => option.value === this.localType[0]
    );
    const firstName = first ? first.name : this.localType[0];
    return this.localType.length > 1
      ? `${firstName}, +${this.localType.length - 1}`
      : firstName;
  }

  get resolvedMisbookingPotential() {
    if (this.localMisbookingYes === this.localMisbookingNo) {
      return "";
    }
    return this.localMisbookingYes ? "yes" : "no";
  }

  get activeFilterCount() {
    let count = 0;
    if (this.status) count += 1;
    if (this.type) count += 1;
    if (this.isCod) count += 1;
    if (this.isMisbookingPotential) count += 1;
    return count;
  }

  get hasActiveFilter() {
    return this.activeFilterCount > 0;
  }

  onReset() {
    this.localStatus = this.statusOptions[0];
    this.localType = [];
    this.localIsCod = this.codOptions[0];
    this.localMisbookingYes = false;
    this.localMisbookingNo = false;
    this.isOpen = false;
    this.$emit("reset");
  }

  onCancel() {
    this.syncFromProps();
    this.isOpen = false;
    this.$emit("cancel");
  }

  onApply() {
    this.isOpen = false;
    this.$emit("apply", {
      status: this.localStatus.value,
      type: this.localType.join(","),
      isCod: this.localIsCod.value,
      isMisbookingPotential: this.resolvedMisbookingPotential
    });
  }
}
